import { GeoCoordinate } from '@/api/types';
import { computeHeading } from './geometry';

/**
 * Creates a google maps street view URL between two sets of coordinates.
 * @param {GeoCoordinate} entryLocation - The entry point location.
 * @param {GeoCoordinate} location - The location used to calculate the heading.
 * @returns {string} - The google maps street view URL.
 */
export function getStreetViewUrl(entryLocation: GeoCoordinate, location: GeoCoordinate): string {
  const heading = computeHeading(entryLocation, location);
  return `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${entryLocation?.latitude},${entryLocation?.longitude}&heading=${heading}`;
}

export function getStreetViewPreviewImageUrl(
  entryLocation: GeoCoordinate,
  location: GeoCoordinate,
  width = 400,
  height = 200
): string {
  const heading = computeHeading(entryLocation, location);
  return `https://maps.googleapis.com/maps/api/streetview?size=${width}x${height}&location=${entryLocation?.latitude},${entryLocation?.longitude}&heading=${heading}&key=${process.env.VUE_APP_GOOGLE_MAPS_API_KEY}`;
}

export function toLatLng(location: GeoCoordinate): google.maps.LatLngLiteral {
  return {
    lat: location.latitude,
    lng: location.longitude
  };
}

export function toLatLngs(locations: GeoCoordinate[]): google.maps.LatLngLiteral[] {
  const latLngs: google.maps.LatLngLiteral[] = [];

  locations.forEach((location) => {
    latLngs.push(toLatLng(location));
  });

  return latLngs;
}

export default {
  getStreetViewUrl,
  getStreetViewPreviewImageUrl,
  toLatLng,
  toLatLngs
};
